export default "__VITE_ASSET__DpsLfHnU__"